module.exports = __webpack_public_path__ + "img/mc-skip.bac51fe0.svg";